export const CORE_AMZL = "AMZL_CORE";
export const AR_V2 = "AR_NEXT_GEN";
export const AR = "AR";
export const SSD = "SSD";
export const EMPTY_STR = "";
export const DEFAULT_REFRESH_INTERVAL = 60 * 1000;  // 1 minute.
export const REVERSE_PICK = "REVERSE_PICK";
export const ANALYTICS_CONFIG = {
    PENDO_API_KEY: "ae299fdb-5276-403c-4b78-dd8b69d722d7",
    ACCOUNT_ID: "SCC - AMZL"
};

export const DARK_MODE = {
    DARK: "dark",
    LIGHT: "light"
}
export const ENTITY_TYPE = {
    CONTAINER: "CONTAINER",
    PACKAGE: "PACKAGE"
}
export const DWP_FILE_UPLOAD_SOURCE = {
    AUTO: "auto",
    MANUAL: "manual"
}
export const CONTAINER_TYPE = {
    BAG: "BAG",
    PACKAGE: "PACKAGE"
}

export const ROUTING_ALGORITHM = {
    DYNAMIC: "DYNAMIC",
    ZONED: "ZONED"
}

export const NOT_IN_CART = "Not In Cart";

export const DEFAULT_SPR_PACKAGE_COUNT = 270;
export const DEFAULT_SPR_TIME_LIMIT = 60;

export const DEFAULT_RC_PACKAGE_COUNT = 0;
export const DEFAULT_RC_TIME_LIMIT = 0;

export const PACKAGE_STATUS = {
    STOW_SUCCESS: "STOW_SUCCESS",
    PLANNED: "PLANNED",
    INDUCTED: "INDUCTED",
    PENDING_REPLAN: "PENDING_REPLAN",
    STOWED_SHELF: "STOWED_SHELF"
}

export const NOT_IN_CART_ELIGIBLE_STATUSES = [
    PACKAGE_STATUS.PLANNED,
    PACKAGE_STATUS.INDUCTED,
    PACKAGE_STATUS.STOWED_SHELF
]

export const HIGH_SPR = "High SPR"

export const ENVIRONMENT = {
    DEV: "development",
    TEST: "test",
    PROD: "production"
}

export const STAGE = {
    DEV: "dev",
    BETA: "beta",
    GAMMA: "gamma",
    PROD: "prod"
}

export const REGION = {
    NA: "US",
    EU: "EU",
    JP: "JP",
    IN: "IN"
}

export const EMPTY_STRING = "";
export const TIMEOUT_STRING = "timeout";

export const FEATURES = {
    IS_TCP_AUTHORIZATION_CHECK: "isForceAssignTCPAuthorizationCheckEnabled",
    IS_RSWS_BOSON_FLOW_ENABLED: "isRSWSBosonFlowEnabled"
}

export const YES = "Yes";
export const NO = "No"

export const MARKETPLACE_LOCALE_MAP = {
    de: ["de", "de-DE", "de-CH", "de-AT", "de-LU", "de-LI"],
    es: ["es", "es-ES", "es-AR", "es-GT", "es-CR", "es-PA", "es-DO", "es-MX", "es-VE", "es-CO",
        "es-PE", "es-EC", "es-CL", "es-UY", "es-PY", "es-BO", "es-SV", "es-HN", "es-NI", "es-PR"],
    ja: ["ja", "ja-JP"],
    it: ["it", "it-IT", "it-CH"],
    fr: ["fr", "fr-FR", "fr-BE", "fr-CA", "fr-CH", "fr-LU"],
    ar: ["ar", "ar-SA", "ar-IQ", "ar-EG", "ar-LY", "ar-DZ", "ar-MA", "ar-TN", "ar-OM", "ar-YE",
        "ar-SY", "ar-JO", "ar-LB", "ar-KW", "ar-AE", "ar-BH", "ar-QA"],
    en: ["en"],
    tr: ["tr", "tr-TR"],
    pt: ["pt", "pt-PT", "pt-BR"]
}

export const LOCALE = {
    AR: "ar",
    DE: "de",
    EN: "en",
    ES: "es",
    FR: "fr",
    IT: "it",
    JA: "ja",
    TR: "tr",
    PT: "pt",
}

export const LOCALE_DIRECTION = {
    RIGHT_TO_LEFT: "rtl",
    LEFT_TO_RIGHT: "lrt",
}

export const TIMEOUTS = {
    RSWS_GET_STATION_ROUTES_API_TIMEOUT: 45000,
    RSWS_DWP_UPLOAD_API_TIMEOUT: 60000,
    RSWS_DEFAULT_API_TIMEOUT: 25000,
}

export const SORT_DIRECTION = {
    ASC: "ascending",
    DESC: "descending"
}

export const BOOLEAN = {
    TRUE: true,
    FALSE: false
}

export const STAGE_LOCATION_TYPE = {
    PLANNED: "PLANNED",
    NORMAL: "NORMAL",
    OVERFLOW: "OVERFLOW",
}

export const PROCESS_NODE_USER = "nodeUser";
export const GET_TCP_ROLES_USING_USER_ID = "getTcpRoles";

export const TCP_ROLES =  {
    US: ["AmazonFacility::Warehouse Manager"],
    EU: ["AmazonFacility::Warehouse Manager"],
    FE: ["AmazonFacility::Warehouse Manager"]
};

export const AMAZON_SUFFIX = "@amazon.com";

export const AR_SSD = [SSD, AR];
export const DEFAULT_CAPABILITIES = [CORE_AMZL, SSD, AR];

export const CACHE_TTL = 50000;

export const TOP_PRIORITY = "1";

export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
    hourCycle: 'h24'
}

export const HEADERS = {
    ROUTES: {
        head: "route.heading",
        headAlt: "Routes",
        desc: "route.description",
        descAlt: "Number of routes where all packages have been processes to the respective state",
        tab: "outboundAMZL.tabHeading",
        tabAlt: "Outbound"
    },
    PICK: {
        head: "pick.heading",
        headAlt: "Pick",
        desc: "pick.description",
        descAlt: "This table shows routes’ status and real-time details during the outbound pick process. You can prioritize, sideline, or unassign routes",
        tab: "outboundAMZL.tabHeading",
        tabAlt: "Outbound"
    },
    PICK_LAYOUT_GRID_VIEW: {
        head: "pick.heading",
        headAlt: "Pick",
        desc: "pick.layoutGridViewDescription",
        descAlt: "This table shows picklists and aisle groups status and real-time details of picking process in the sort grid",
        tab: "outboundAMZL.tabHeading",
        tabAlt: "Outbound"
    },
    PICK_AR_V2: {
        head: "pickARv2.heading",
        headAlt: "Outbound Pick",
        desc: "pickARv2.description",
        descAlt: "View the status and progress of outbound routes and pick stations in the Pick process. Check for unassigned routes and cut any delayed routes",
        tab: "outboundAMZL.tabHeading",
        tabAlt: "Outbound"
    }
}


// WEBPACK FOOTER //
// ./src/components/util/Constants.js